<template>
  <div>
    <el-tooltip :content="$t('reportingProfiles.create.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="primary" @click="modal = true">
        <span class="mdi mdi_icon mdi-24px mdi-plus"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="card-title d-inline">{{$t('reportingProfiles.create.titleText')}}</h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('reportingProfiles.create.helpText') }}</small>
        </div>
        <form role="form" v-on:submit.prevent="create()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.label') }}</label>
            <div class="col-md-9">
              <base-input
                name="label"
                :error="getError('note')"
                v-model="profile.label"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.contact_name') }}</label>
            <div class="col-md-9">
              <base-input
                name="name"
                v-validate="modelValidations.required"
                :error="getError('contact_name')"
                v-model="profile.contact_name"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.contact_surname') }}</label>
            <div class="col-md-9">
              <base-input
                name="surname"
                v-validate="modelValidations.required"
                :error="getError('contact_surname')"
                v-model="profile.contact_surname"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.email') }}</label>
            <div class="col-md-9">
              <base-input
                type="email"
                name="email"
                v-validate="modelValidations.email"
                :error="getError('email')"
                v-model="profile.email"
              >
              </base-input>
            </div>
          </div>
          <base-alert v-if="error" type="danger">
            <!-- TODO: add error translation -->
            {{ error }}
          </base-alert>

          <div class="text-center">
            <base-button
              type="primary"
              class="my-4"
              @click="validate()"
            >{{ $t('reportingProfiles.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
  import {BaseAlert, Modal} from 'src/components';
  import {Option, Select} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'create-reporting-profile',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      BaseAlert
    },
    data() {
      return {
        modal: false,
        alert: false,
        profile: {
          name: '',
          surname: '',
          email: '',
          note: '' // required note
        },
        modelValidations: {
          required: {
            required: true
          },
          email: {
            email: true,
            required: true
          },
          number: {
            numeric: true
          },
          url: {
            url: true
          },
          equalToSource: {
            required: true
          },
          equalToDest: {
            required: true,
            confirmed: 'equalToSource'
          }
        }
      }
    },
    computed: {
      ...mapState({
        error: state => state.reporting_profile.error,
        createdProfile: state => state.reporting_profile.createdProfile,
      }),
    },
    methods: {
      ...mapActions(['CreateReportingProfile']),
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid);
          if (isValid) {
            this.create()
          }
        });
      },
      create: function () {
        this.CreateReportingProfile(this.profile).then(() => {
          if (this.error) {
            this.alert = true
          } else {
            // Close modal
            this.resetForm()
            this.$router.push({
              name: 'reporting-profile-view',
              params: {id: this.createdProfile.id}
            }).catch(err => {
            })
          }
        });
      },
      resetForm: function () {
        // closing dialog
        this.modal = false

        // resetting form
        this.profile.name = ''
        this.profile.contact_surname = ''
        this.profile.email = ''
        this.profile.label = ''

        // reset validation errors
        this.$validator.reset()
      },
    }
  }
</script>
